"use strict";

import Swiper from "swiper";
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';
import "swiper/css";

const swipers = document.querySelectorAll(
    ".wp-block-pulp-testimonial-carousel .swiper"
);

swipers.forEach((el, index) => {
    const swiper = new Swiper(el, {
        modules: [Autoplay, FreeMode, Navigation],
        slidesPerView: 1,
        loop: true,
        // autoplay: {
        //     delay: 4000,
        // },
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
        // speed: 3000,
        // autoplay: {
        //     delay: 0 // this prevent pauseOnMouseHover from working
        // },
        // freeMode: {
        //     enabled: true
        // }
    });

    swiper.on('slideChange', function () {
        $(el).find('.swiper-counter .current-slide').text(swiper.realIndex + 1);
    });
});
